var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#827415", fillRule: "evenodd", d: "M3.75 18h16.5a.75.75 0 0 1 .738.615l.012.135v1.5a.75.75 0 0 1-.615.738L20.25 21H3.75a.75.75 0 0 1-.738-.616L3 20.25v-1.5a.75.75 0 0 1 .615-.738L3.75 18h16.5-16.5zm7.27-15h1.96c.268 0 .513.142.646.367l.057.119L18 15H6l4.317-11.514a.75.75 0 0 1 .572-.474L11.02 3h1.959-1.96z" })
  );
});